import React, { useState } from 'react'
import { ChangeMarkPointProps } from './ChangeMarkPoint.types'
import styles from './ChangeMarkPoint.module.scss'
import cl from 'classnames'
import { LetterMark } from '../LetterMark'
import { ChangePlate } from '../ChangePlate'
import { useChangePlageAbsolutePosition } from './ChangeMarkPoint.utils'

const ChangeMarkPointComponent = (props: ChangeMarkPointProps) => {
  const {
    className,
    style,
    plateStyleProps: {
      style: platePropStyle,
      className: platePropClassName
    } = {},
    ...versionChange
  } = props

  const {
    containerRef,
    plateStyle
  } = useChangePlageAbsolutePosition()
  const [showPlate, setShowPlate] = useState<boolean>(false)

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
      ref={containerRef}
      onMouseEnter={() => setShowPlate(true)}
      onMouseLeave={() => setShowPlate(false)}
    >
      <LetterMark letter={versionChange.markLetter} />

      {showPlate && (
        <ChangePlate
          className={cl(styles.changePlate, platePropClassName)}
          style={{
            ...plateStyle,
            ...platePropStyle
          }}
          {...versionChange}
        />
      )}
    </div>
  )
}

const ChangeMarkPoint = ChangeMarkPointComponent
export { ChangeMarkPoint }
